import React, { useEffect, useState, useRef, useContext } from 'react'
import { Button, Col, Form, FormControl, InputGroup, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row, Tab, Tabs } from 'react-bootstrap'
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import defaultPalettes from '../Palettes';
import GlobalContext from '../GlobalContext';
import ImageInput from '../components/ImageInput';
import { useNavigate } from 'react-router-dom';
import { useImmer } from 'use-immer';
import "../css/sidebar.css"
import "../css/inputs.css"
import { RiDeleteBin6Line, RiFontSize, RiCheckLine, RiCloseLine, RiContactsBookLine, RiCalendar2Line, RiMenuAddLine, RiEraserLine, RiGoogleLine, RiBarChart2Line } from 'react-icons/ri'
import { AiFillEyeInvisible, AiOutlineNotification } from 'react-icons/ai'
import GoodCheck from '../components/GoodCheck';
import ServiceContext from '../ServiceContext';
import TextContext from '../TextContext';
import socketIO from "socket.io-client";
import GoodNumber from '../components/GoodNumber';
import GroupSettings from './GroupSettings';
import ThemeSettings from './ThemeSettings';
import ShopSettings from './ShopSettings';
import CalendarContext from '../CalendarContext';
import EventEditor from './EventEditor';
import UsersSettings from './UsersSettings';


const defCategories = [
    {
        ID: 0,
        cat_name: "nocategory",
        cat_apt: 0,
        cat_color: "#ff00ff",
        loaded: true
    }
]
const Sidebar = () => {
    const globalContext = useContext(GlobalContext)
    const serviceContext = useContext(ServiceContext)
    const textContext = useContext(TextContext)
    const calendarContext = useContext(CalendarContext)
    const navigate = useNavigate()
    const animatedComponents = makeAnimated();
    const socket = useRef(false)

    const [activeTab, setActiveTab] = useState("t1")
    const [image, setImage] = useState(undefined)
    const [showSettings, setShowSettings] = useState(false)
    const [password, setPassword] = useState()
    const [passwordMessage, setPasswordMessage] = useState({ type: 0, mess: '' })
    const [showPassword, setShowPassword] = useState(false)
    const [groupOptions, setGroupOptions] = useState([])
    const [addGroup, setAddGroup] = useState(false)
    const [showDelConfirm, setShowDelConfirm] = useState(false)
    const [relaodPic, setReloadPic] = useState(false)
    const [showUsernameTakenMessage, setShowUsernameTakenMessage] = useState(false)
    const [languageOptions, setLanguageOptions] = useState([])
    const [selectedUserLanguage, setSelectedUserLanguage] = useState({ label: undefined, value: null })
    const [submitUserSettings, setSubmitUserSettings]=useState(false)
    const [clearUserSettings, setClearUserSettings]=useState(false)
    const [submitGroup, setSubmitGroup] = useState(false)
    const [submitShop, setSubmitShop] = useState(false)
    const [deleteGroup, setDeleteGroup] = useState(false)
    const [editProfileValues, setEditProfileValues] = useImmer({
        use_username: undefined,
        calendar_hours_start: 18,
        calendar_hours_end: 15
    })
    const [editProfileCheks, setEditProfileCheks] = useImmer({
        touched: {
            use_username: false,
            calendar_hours_start: false,
            calendar_hours_end: false,
        },
        check: {
            use_username: (v) => { return v && v.length > 0 && v.length < 15 },
            calendar_hours_start: (v) => { return v && v >= 0 },
            calendar_hours_end: (v) => { return v && v <= 24 },
        },
        good: {
            use_username: false,
            calendar_hours_start: false,
            calendar_hours_end: false,
        },
        bad: {
            use_username: false,
            calendar_hours_start: false,
            calendar_hours_end: false,
        },
    })

    const spawnRandomAlert = () => {
        serviceContext.set(draft => {
            draft.Alerts.push({
                ID: Math.random(),
                message: 'Ciao sono una notifica!',
                ttl: 4000
            })
        })
    }
    const changeLanguage = async (e) => {
        setSelectedUserLanguage(e)
        textContext.set(draft => { draft.activeLang = e.value })
    }
    const changeTab = (newTab) => {
        setActiveTab(newTab)
    }
    const checkEditProfile = () => {
        if (checkForm(editProfileValues, editProfileCheks, setEditProfileCheks, true)) {
            if (editProfileValues.calendar_hours_start <= editProfileValues.calendar_hours_end - 2) {
                if (editProfileValues.use_username !== globalContext.get.User.use_username || editProfileValues.calendar_hours_start !== globalContext.get.User.use_calendar_start || editProfileValues.calendar_hours_end !== globalContext.get.User.use_calendar_end) {
                    globalContext.set(draft => {
                        draft.User.use_username = editProfileValues.use_username;
                        draft.User.use_calendar_start = editProfileValues.calendar_hours_start;
                        draft.User.use_calendar_end = editProfileValues.calendar_hours_end;
                    })
                }
            }
        }
    }
    const checkForm = (values, check, setCheck, show = false) => {
        try {
            let pass = true
            Object.keys(values).forEach(k => {
                if (check.check.hasOwnProperty(k)) {
                    if (check.check[k](values[k])) {

                        if (show || check.touched[k]) {
                            setCheck(draft => { draft.good[k] = true })
                            setCheck(draft => { draft.bad[k] = false })
                        }
                    } else {
                        pass = false

                        if (show || check.touched[k]) {
                            setCheck(draft => { draft.bad[k] = true })
                            setCheck(draft => { draft.good[k] = false })
                        }
                    }
                } else {
                    //console.log('CHECK: proprietà non trovata:', k)
                }

            })
            return pass
        } catch (e) {
            console.log('Errore nel check', e)
            return false
        }
    }
    const connectGoogle = async () => {
        const resp = await fetch(`${globalContext.get.backendUrl}/gapiv1/url`, {
            method: 'GET',
            credentials: 'include'
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            window.location.href = respValue.data.url

        }
    }
    // const connectSocket = async (shops) =>{
    //     socket.current = socketIO.connect(globalContext.get.backendUrl)
    //     console.log('connetti socket')
    //     socket.current.on('connect', () => {
    //         // console.log('connesso', socket)
    //         socket.current.emit('shops', { shops: shops })
    //     })
    //     socket.current.on('disconnect', (reason)=>{
    //         // console.log('disconnesso', reason, socket)
    //         globalContext.set(draft => { draft.socket = false})
    //     })
    //     socket.current.on('refresh_events', () => {
    //         // console.log('refresh_events')
    //         globalContext.set(draft => { draft.Reloads.events = true })
    //     })
    //     socket.current.on('refresh_customers', () => {
    //         // console.log('refresh_customers')
    //         globalContext.set(draft => { draft.Reloads.customers = true })
    //     })
    //     socket.current.on('refresh_requests', () => {
    //         // console.log('refresh_requests')
    //         globalContext.set(draft => { draft.Reloads.customerRequests = true })
    //     })
    //     globalContext.set(draft => { draft.socket = socket.current })
    // }
    const disconnectGoogle = async () => {
        const resp = await fetch(`${globalContext.get.backendUrl}/gapiv1/auth`, {
            method: 'DELETE',
            credentials: 'include'
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            //window.location.href = respValue.data.url
            globalContext.set(draft => { draft.Reloads.user = true; })
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['google_disconnect'], textContext.value),
                    ttl: 2000
                })
            })
        } else {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_disconnect'], textContext.value),
                    ttl: 2000
                })
            })
        }
    }
    const editPassword = async (ID) => {
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        const body = {
            ID: ID,
            use_password: password
        }
        //console.log(body)
        let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/users`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
        let respValue = await resp.json()
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
        if (resp.status == 200) {
            setPasswordMessage({ type: 1, mess: textContext.get(['sidebar', 'settings', 'shop'], ['psw_change'], textContext.value) })
            setPassword('')
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['success_password'], textContext.value),
                    ttl: 2000
                })
            })
            setTimeout(() => {
                navigate('/')
            }, 2000)
        } else if (resp.status == 400) {
            setPasswordMessage({ type: -1, mess: textContext.get(['sidebar', 'settings', 'shop'], ['psw_bleh'], textContext.value) })
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['skillissue_psw'], textContext.value),
                    ttl: 2000
                })
            })
        } else {
            setPasswordMessage({ type: -1, mess: textContext.get(['sidebar', 'settings', 'shop'], ['error'], textContext.value) })
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_psw'], textContext.value),
                    ttl: 2000
                })
            })
        }

    }
    const editUser = async (close = true) => {
        let body = {}
        if (defaultPalettes.filter(pal => pal.name == globalContext.get.Theme.name).length > 0) {
            body = {
                ID: globalContext.get.User.ID,
                use_username: globalContext.get.User.use_username,
                use_language: selectedUserLanguage.value,
                use_calendar_start: globalContext.get.User.use_calendar_start,
                use_calendar_end: globalContext.get.User.use_calendar_end,
                use_calendar_hour_format: globalContext.get.User.use_calendar_hour_format,
                use_palette_ID: null,
                use_palette_name: globalContext.get.Theme.name,
            }
        } else {
            const ID = globalContext.get.User.Palettes.filter(pa => pa.pal_name == globalContext.get.Theme.name)[0].ID
            body = {
                ID: globalContext.get.User.ID,
                use_username: globalContext.get.User.use_username,
                use_language: selectedUserLanguage.value,
                use_calendar_start: globalContext.get.User.use_calendar_start,
                use_calendar_end: globalContext.get.User.use_calendar_end,
                use_calendar_hour_format: globalContext.get.User.use_calendar_hour_format,
                use_palette_ID: ID,
                //use_palette_name: globalContext.get.Theme.name,
            }
        }
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        //console.log(body)
        setShowUsernameTakenMessage(false)
        let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/users`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['modify_utent'], textContext.value),
                    ttl: 2000
                })
            })
        } else if (resp.status === 201) {
            setShowUsernameTakenMessage(true)
            close = false
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['used_username'], textContext.value),
                    ttl: 2000
                })
            })
        } else {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_modify_utent'], textContext.value),
                    ttl: 2000
                })
            })
        }

        if (image) {
            const formData = new FormData()
            formData.append("image", image)
            await fetch(`${globalContext.get.backendUrl}/papiv1/pic`, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                },
                body: formData
            })
            setReloadPic(!relaodPic)
        }
        // loadUser(true)
        if (close) {
            setShowSettings(false)
            setActiveTab("t1")
        }
        
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })

    }
    const getPermission = (permission, pos = -1) => {
        if (globalContext.get) {
            if (globalContext.get.User) {
                if (globalContext.get.User.Groups) {
                    if (globalContext.get.User.Groups.length > 0) {
                        if (globalContext.get.User.Groups[0].gro_is_admin) {
                            return true
                        } else {
                            if (pos >= 0) {
                                return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos))
                            } else {
                                return globalContext.get.User.Groups[0][permission]
                            }
                        }
                    }
                }
            }
        }
        return false
    }
    // const loadAgency = async (isLoading = false) => {
    //     let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/agencys`, {
    //         method: 'GET',
    //         credentials: 'include'
    //     })
    //     let respValue = await resp.json()

    //     if (resp.status == 200) {
    //         globalContext.set(draft => { draft.Agency = respValue.data })
    //         if (isLoading) {
    //             serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
    //         }
    //     }
    //     resp = await fetch(`${globalContext.get.backendUrl}/papiv1/openings`, {
    //         method: 'GET',
    //         credentials: 'include'
    //       })
    //       respValue = await resp.json()

    //       if (resp.status == 200) {
    //         globalContext.set(draft => { draft.openings = respValue.data })
    //         calendarContext.set(draft=>{draft.resetOpenDates=true})
    //       }
    // }
    // const loadCategories = async (isLoading = false) => {
    //     let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/categorys`, {
    //         method: 'GET',
    //         credentials: 'include'
    //     })
    //     let respValue = await resp.json()
    //     if (resp.status == 200) {
    //         globalContext.set(draft => { draft.categories = defCategories.concat(respValue.data); })
    //         if (isLoading) {
    //             serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
    //         }
    //         calendarContext.set(draft=>{draft.refreshCategories=true})
    //         setInterval(()=>{
    //             calendarContext.set(draft=>{draft.refreshCategories=false})
    //         },1000)
    //     }
    // }
    // const loadCustomers = async (isLoading = false) => {
    //     let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/customers`, {
    //         method: 'GET',
    //         credentials: 'include'
    //     })
    //     const respValue = await resp.json()

    //     if (resp.status == 200) {
    //         globalContext.set(draft => { draft.customers = respValue.data })
    //         if (isLoading) {
    //             serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
    //         }
    //     }
    // }
    // const loadUser = async (isLoading = false) => {
    //     const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/users`, {
    //         method: 'GET',
    //         credentials: 'include'
    //     })
    //     const respValue = await resp.json()

    //     if (resp.status == 200) {
    //         const user = {
    //             ID: respValue.data.ID,
    //             use_username: respValue.data.use_username,
    //             use_message: respValue.data.use_message,
    //             use_language: respValue.data.use_language,
    //             use_message_time: respValue.data.use_message_time,
    //             use_calendar_start: respValue.data.use_calendar_start,
    //             use_calendar_end: respValue.data.use_calendar_end,
    //             use_calendar_hour_format: respValue.data.use_calendar_hour_format,
    //             use_round_corner: respValue.data.use_round_corner,
    //             use_palette_ID: respValue.data.use_palette_ID,
    //             use_palette_name: respValue.data.use_palette_name,
    //             use_last_read: respValue.data.use_last_read,
    //             use_gapi_logged: respValue.data.use_gapi_logged,
    //             Palettes: respValue.data.Palettes,
    //             Groups: respValue.data.UserGroups.map(ug => ug.Group)
    //         }
    //         //console.log(user)
    //         if (user.use_palette_ID) {
    //             const Theme = {
    //                 name: respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].pal_name,
    //                 palette: [
    //                     respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_1,
    //                     respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_2,
    //                     respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_3,
    //                     respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_4,
    //                     respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_5,
    //                     respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_6,
    //                     respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_7,
    //                 ],
    //                 text_font: respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].Font.fon_text,
    //                 title_font: respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].Font.fon_title,
    //                 text_size: respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].Font.fon_size,
    //             }
    //             //console.log("shops", respValue.data.Shops)
    //             globalContext.set(draft => { draft.User = user; draft.Shop = respValue.data.Shop; draft.shops = respValue.data.Shops; draft.selectedShop = respValue.data.Shop; draft.Theme = Theme; })
    //         } else {
    //             //console.log("shops", respValue.data.Shops)
    //             globalContext.set(draft => { draft.User = user; draft.Shop = respValue.data.Shop; draft.shops = respValue.data.Shops; draft.selectedShop = respValue.data.Shop; draft.Theme = defaultPalettes.filter(pal => pal.name == user.use_palette_name)[0] })
    //         }

    //         if (user.use_language) {
    //             // console.log('lingua user:', user.use_language)
    //             textContext.set(draft => { draft.activeLang = user.use_language })
    //         } else {
    //             // console.log('lingua shop:', respValue.data.Shop.sho_language)
    //             textContext.set(draft => { draft.activeLang = respValue.data.Shop.sho_language })
    //         }

    //         loadAgency(isLoading)
    //     }
    // }
    const setCssVariables = () => {
        let css = `
        :root {
            --palette-background-1: ${globalContext.get.Theme.palette[1]}!important; 
            --palette-background-2: ${globalContext.get.Theme.palette[0]}!important; 
            --palette-background-3: ${globalContext.get.Theme.palette[2]}!important;
            --ligth-text-color: ${globalContext.get.Theme.palette[4]}!important;  
            --dark-text-color: ${globalContext.get.Theme.palette[3]}!important;  
            --box-shadow-color: ${globalContext.get.Theme.palette[5]}!important;  
            --accent-text-color: ${globalContext.get.Theme.palette[6]}!important; 
            --title-font-size: ${parseFloat(globalContext.get.Theme.text_size) + 2}pt;
            --text-font-size: ${globalContext.get.Theme.text_size}pt; 
            --text-font: ${globalContext.get.Theme.text_font};
            --title-font: ${globalContext.get.Theme.title_font};
        }
           `
        // globalContext.get.categories.forEach(cat => {
        //     css = css.concat(GetTextColorClass(cat))
        // })
        style.innerHTML = css;
        document.getElementsByTagName('head')[0].appendChild(style);
    }
    const removeLang = () => {
        setSelectedUserLanguage({ label: undefined, value: null })
        textContext.set(draft => { draft.activeLang = globalContext.get.Shop.sho_language })
    }

    const style = document.createElement('style');
    style.type = 'text/css';

    useEffect(() => {
        if (!globalContext.get.User.ID) {
            globalContext.set(draft => {
                draft.Reloads.user = true
                draft.Reloads.agency = true
                draft.Reloads.categories = true
                draft.Reloads.customers = true
            })
        }
        //console.log(window.location.pathname.split("/").pop() == 'calendar')
    }, [])
    useEffect(() => {
        if (serviceContext.get && serviceContext.get.showSettings) {
            temp.current = globalContext.get;
            setShowSettings(true)
            serviceContext.set(draft => { draft.showSettings = false })
        }
    }, [serviceContext.get])
    useEffect(() => {
        if (globalContext.get) {
            // if (!globalContext.get.loaded) {
            //     console.log('globalcontext not loaded')
            //     loadCategories()
            //     loadCustomers()
            //     loadUser()
            //     globalContext.set(draft=>{draft.loaded=true})
            // }
            setCssVariables() //imposta le variabili del tema
            if (globalContext.get.User.ID) {
                const shops = globalContext.get.shops.map(sho => sho.ID)
                setEditProfileValues({
                    use_username: globalContext.get.User.use_username,
                    calendar_hours_start: globalContext.get.User.use_calendar_start,
                    calendar_hours_end: globalContext.get.User.use_calendar_end,
                })
                // if (!globalContext.get.socket) {
                //     connectSocket(shops)
                // }
                if (globalContext.get.User.use_language) {
                    setSelectedUserLanguage({ label: textContext.value.texts[globalContext.get.User.use_language].sidebar.settings.profile.language_name, value: globalContext.get.User.use_language })
                }
            }
            if (globalContext.get.User.ID && globalContext.get.Shop.ID && globalContext.get.Agency.ID) {
                let l_users = []
                let ids = []
                let l_groups = []
                //console.log('ESECUZIONE loop')
                globalContext.get.shops.forEach(sho => {
                    sho.Users.forEach(use => {
                        if (!ids.includes(use.ID)) {
                            ids.push(use.ID)
                            l_users.push(use)
                        }
                    })
                })

                const userGroup = globalContext.get.User.Groups[0]
                globalContext.get.Agency.Groups.forEach(gro => {
                    if (userGroup.gro_is_admin) {
                        if (!(gro.gro_is_admin && gro.gro_priority > userGroup.gro_priority)) {
                            l_groups.push({ label: gro.gro_name, value: gro.ID })
                        }
                    } else if (userGroup.gro_manage_groups) {
                        if (!(gro.gro_is_admin || gro.gro_priority > userGroup.gro_priority || gro.ID == userGroup.ID)) {
                            l_groups.push({ label: gro.gro_name, value: gro.ID })
                        }
                    }
                })
                setGroupOptions(l_groups)
            }
            // if (globalContext.get.Reloads.user) {
            //     loadUser(false)
            //     globalContext.set(draft => { draft.Reloads.user = false })
            // }
            // if (globalContext.get.Reloads.categories) {
            //     loadCategories()
            //     globalContext.set(draft => { draft.Reloads.categories = false;draft.Reloads.events = true  })
            // }
            // if (globalContext.get.Reloads.customers) {
            //     if(globalContext.get.PreventReloads.customers){
            //         globalContext.set(draft => { draft.Reloads.customers = false;draft.PreventReloads.customers = false  })
            //     } else {
            //         loadCustomers()
            //         globalContext.set(draft => { draft.Reloads.customers = false })
            //     }
            // }
            // if (globalContext.get.Reloads.agency) {
            //     loadAgency()
            //     globalContext.set(draft => { draft.Reloads.agency = false })
            // }

        }
    }, [globalContext.get])
    useEffect(() => {
        //console.log('useeffect li',textContext.value)
        if (textContext.value.activeLang) {
            setLanguageOptions(Object.keys(textContext.value.texts).map(lang => ({ label: textContext.value.texts[lang].sidebar.settings.profile.language_name, value: lang })))
        }
    }, [textContext])
    useEffect(() => {
        checkEditProfile()
    }, [editProfileValues])
    // useEffect(()=>{
    //     if(relaodPic){
    //         setReloadPic(false)
    //     }
    // },[relaodPic])


    const temp = useRef()

    return (
        <Col className='sidebar-sidebar' style={{ backgroundColor: globalContext.get.Theme.palette[2], height: "95vh" }}>
            <Row className='mt-4 d-flex justify-content-center sidebar-profile-pic-row '>
                <img className='sidebar-profile-pic' src={`${globalContext.get.backendUrl}/papiv1/picGet?r=${relaodPic}&backend_version=11`} onClick={() => { temp.current = globalContext.get; setShowSettings(true) }} />
                <p className=' mt-2 d-flex justify-content-center'>{globalContext.get.User.use_username}</p>
            </Row>
            <hr className='hr-cool' style={{ height: '2px' }} />
            <Row className='mt-4 sidebar-calendar d-flex justify-content-center mb-4 ' style={{ cursor: 'pointer' }} onClick={() => navigate("/calendar")} >
                <div className={`sidebar-button-container d-flex justify-content-center ${window.location.pathname.split("/").pop() == 'calendar' && 'sidebar-button-container-selected'}`} >
                    <RiCalendar2Line size={`34pt`} className='sidebar-sidebar-text' />
                </div>
            </Row>
            <Row className='mt-1 sidebar-customers d-flex justify-content-center mb-4     ' style={{ cursor: 'pointer' }} onClick={() => navigate("/customers")}>
                <div className={`sidebar-button-container d-flex justify-content-center ${window.location.pathname.split("/").pop() == 'customers' && 'sidebar-button-container-selected'}`} >
                    <RiContactsBookLine size={`34pt`} className='sidebar-sidebar-text' />
                </div>
            </Row>
            {/* <Row className='mt-1 sidebar-customers d-flex justify-content-center mb-4     ' style={{ cursor: 'pointer' }} onClick={spawnRandomAlert}>
                <div className={`sidebar-button-container d-flex justify-content-center`} >
                    <AiOutlineNotification size={`34pt`} className='sidebar-sidebar-text' />
                </div>
            </Row> */}
            <Row className='mt-1 d-flex justify-content-center mb-4     ' style={{ cursor: 'pointer' }} onClick={() => navigate("/statistics")}>
                <div className={`sidebar-button-container d-flex justify-content-center ${window.location.pathname.split("/").pop() == 'statistics' && 'sidebar-button-container-selected'}`} >
                    <RiBarChart2Line size={`34pt`} className='sidebar-sidebar-text' />
                </div>
            </Row>

            <Modal show={showSettings} onHide={() => { setShowSettings(false); setActiveTab("t1") }}>
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title light-color'>{textContext.get(['sidebar', 'settings'], ['title'], textContext.value)}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <Tabs
                            defaultActiveKey="t1"
                            id="uncontrolled-tab-example"
                            className="mb-3"
                            activeKey={activeTab}
                            onSelect={(k) => changeTab(k)}
                        >
                            <Tab eventKey="t1" title={textContext.get(['sidebar', 'settings', 'profile'], ['title'], textContext.value)}>
                                {getPermission('gro_edit_pic') ? (
                                    <Row className='mt-4 d-flex justify-content-center'>
                                        <ImageInput
                                            onChange={(e) => setImage(e.target.files[0])}
                                            filename={image}
                                            defaultImage={`${globalContext.get.backendUrl}/papiv1/picGet?backend_version=11`}
                                        />
                                    </Row>
                                ) : (<></>)}
                                {getPermission('gro_edit_username') ? (
                                    <Row className='mt-4'>
                                        <InputGroup hasValidation>
                                            <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'profile'], ['user_username'], textContext.value)}</InputGroup.Text>
                                            <FormControl
                                                type='text'
                                                placeholder='giorgio67'
                                                value={editProfileValues.use_username}
                                                onChange={(e) => setEditProfileValues(draft => { draft.use_username = e.target.value })}
                                                onFocus={(e) => setEditProfileCheks(draft => { draft.touched.use_username = true })}
                                                isValid={editProfileCheks.good.use_username}
                                                isInvalid={editProfileCheks.bad.use_username}
                                            />
                                        </InputGroup>
                                        {showUsernameTakenMessage ? (
                                            <p className='nac-text active' style={{ textAlign: 'end' }}>{textContext.get(['sidebar', 'settings', 'profile'], ['user_username_taken'], textContext.value)}</p>
                                        ) : (<></>)}
                                    </Row>
                                ) : (<></>)}
                                {getPermission('gro_edit_password') ? (
                                    <Row className='mt-4'>
                                        <InputGroup>
                                            <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'profile'], ['user_password'], textContext.value)}</InputGroup.Text>
                                            <FormControl
                                                type={showPassword ? 'text' : 'password'}
                                                placeholder='password'
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                className='password-form'
                                            />
                                            <button type='button' className='showPassword-container nac-button'>
                                                <AiFillEyeInvisible className='nac-text showPassword' size={'15pt'} onClick={() => { setShowPassword(!showPassword) }} />
                                            </button>
                                            <button type='button' className='nac-button save-password-button' onClick={() => editPassword(globalContext.get.User.ID)}>
                                                <RiCheckLine size={'15pt'} />
                                            </button>
                                        </InputGroup>
                                        <p className='nac-text active' style={{ textAlign: 'end' }}>{passwordMessage.mess}</p>
                                    </Row>
                                ) : (<></>)}
                                <Row className='mt-4'>
                                    <Form.Label><p>{textContext.get(['sidebar', 'settings', 'profile'], ['language_select'], textContext.value)}</p></Form.Label>
                                    <span style={{ display: 'flex', flexDirection: 'row' }}>
                                        <span style={{ width: '85%' }} >
                                            <Select
                                                id='select-pttp'
                                                components={animatedComponents}
                                                options={languageOptions}
                                                value={selectedUserLanguage}
                                                onChange={(e) => changeLanguage(e)}
                                            />
                                        </span>
                                        <button type='button' className='mx-2 nac-button save-password-button' onClick={removeLang}>
                                            <RiEraserLine size={'14pt'} />
                                        </button>
                                    </span>
                                </Row>
                                {getPermission('gro_edit_hours') ? (
                                    <>
                                        <hr />
                                        <Row className='mt-4'>
                                            <p>{textContext.get(['sidebar', 'settings', 'profile'], ['cal_hours_title'], textContext.value)}</p>
                                            <Col>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'profile'], ['cal_hours_start'], textContext.value)}</InputGroup.Text>
                                                    <GoodNumber
                                                        value={editProfileValues.calendar_hours_start}
                                                        min={1}
                                                        classes='form-control'
                                                        max={editProfileValues.calendar_hours_end}
                                                        onChange={(e) => setEditProfileValues(draft => { draft.calendar_hours_start = e })}
                                                        onFocus={(e) => setEditProfileCheks(draft => { draft.touched.calendar_hours_start = true })}
                                                        isValid={editProfileCheks.good.calendar_hours_start}
                                                        isInvalid={editProfileCheks.bad.calendar_hours_start}

                                                    />
                                                </InputGroup>
                                            </Col>
                                            <Col>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'profile'], ['cal_hours_end'], textContext.value)}</InputGroup.Text>
                                                    <GoodNumber
                                                        value={editProfileValues.calendar_hours_end}
                                                        min={editProfileValues.calendar_hours_start}
                                                        max={24}
                                                        onChange={(e) => setEditProfileValues(draft => { draft.calendar_hours_end = e })}
                                                        onFocus={(e) => setEditProfileCheks(draft => { draft.touched.calendar_hours_end = true })}
                                                        isValid={editProfileCheks.good.calendar_hours_end}
                                                        isInvalid={editProfileCheks.bad.calendar_hours_end}
                                                        classes='form-control'
                                                    />
                                                </InputGroup>
                                            </Col>
                                        </Row>
                                    </>
                                ) : (<></>)}
                                {globalContext.get.Agency && globalContext.get.Agency.age_enable_drive_api && (
                                    <>
                                        <hr />
                                        <Row className='mt-4'>
                                            <p className='nac-title'>{textContext.get(['sidebar', 'settings', 'profile'], ['g_account'], textContext.value)}</p>
                                            {globalContext.get.User.use_gapi_logged ? (
                                                <div className='sidebar-google-container'>
                                                    <span className='nac-text sidebar-google-label'>{textContext.get(['sidebar', 'settings', 'profile'], ['g_connect'], textContext.value)}</span>
                                                    <button type='button' onClick={disconnectGoogle} className='nac-button sidebar-google-button'>{textContext.get(['sidebar', 'settings', 'profile'], ['g_disconnect'], textContext.value)} <RiGoogleLine size={'14pt'} /> </button>
                                                </div>
                                            ) : (
                                                <div className='sidebar-google-container'>
                                                    <span className='nac-text sidebar-google-label'>{textContext.get(['sidebar', 'settings', 'profile'], ['g_notconnect'], textContext.value)}</span>
                                                    <button type='button' onClick={connectGoogle} className='nac-button sidebar-google-button'>{textContext.get(['sidebar', 'settings', 'profile'], ['g_login'], textContext.value)} <RiGoogleLine size={'14pt'} /> </button>
                                                </div>
                                            )}
                                        </Row>
                                    </>
                                )}
                            </Tab>
                            {getPermission('gro_aer_shop', 1) ? (
                                <Tab eventKey="t4" className='sidebar-settings-t4' title={textContext.get(['sidebar', 'settings', 'shop'], ['title'], textContext.value)}>
                                    <ShopSettings
                                        submitShop={{ get: submitShop, set: setSubmitShop }}
                                        groupOptions={groupOptions}
                                        languageOptions={languageOptions}
                                    />
                                </Tab>
                            ) : (<></>)}
                            {(getPermission('gro_aer_user', 0) || getPermission('gro_aer_user', 1) ) ? (
                                <Tab eventKey="t6" className='sidebar-settings-t4' title={textContext.get(['sidebar', 'settings', 'shop'], ['t_user'], textContext.value)} >
                                    <UsersSettings
                                        submitSignal={{set: setSubmitUserSettings, get: submitUserSettings}}
                                        clearSignal={{set: setClearUserSettings, get: clearUserSettings}}
                                        groupOptions={groupOptions}
                                        languageOptions={languageOptions}
                                    />
                                </Tab>
                            ) : (<></>)}
                            {getPermission('gro_is_admin') && (
                                <Tab eventKey="t5" className='sidebar-settings-t4' title={textContext.get(['sidebar', 'settings', 'groups'], ['title'], textContext.value)}>
                                    <GroupSettings
                                        submit={{ get: submitGroup, set: setSubmitGroup }}
                                        deleteSubmit={{ get: deleteGroup, set: setDeleteGroup }}
                                        addGroup={addGroup}
                                        setAddGroup={setAddGroup}
                                        groupOptions={groupOptions}
                                    />
                                </Tab>
                            )}
                            {getPermission('gro_change_theme') && (
                                <Tab eventKey="t2" title={textContext.get(['sidebar', 'settings', 'theme'], ['title'], textContext.value)}>
                                    <ThemeSettings
                                        setShowSettings={setShowSettings}
                                        editUser={editUser}
                                        temp={temp}
                                    />
                                </Tab>
                            )}
                        </Tabs>
                    </Form>
                </ModalBody>
                {activeTab == "t3" ? (
                    <></>
                ) : ["t1", 't2'].includes(activeTab) ? (
                    <ModalFooter className='d-block'>
                        <Row>
                            <Col xs={9} >
                            </Col>
                            <Col xs={2} className='d-flex justify-content-center'>
                                <button type="button" className='nac-button' onClick={() => { globalContext.set(temp.current); setShowSettings(false); setActiveTab("t1") }}>
                                    <RiCloseLine size={`24pt`} />
                                </button>
                            </Col>
                            <Col xs={1} className='d-flex justify-content-center'>
                                <button type="button" className='nac-button' onClick={() => editUser()}>
                                    <RiCheckLine size={`24pt`} />
                                </button>
                            </Col>
                        </Row>
                    </ModalFooter>
                ) : activeTab == "t4" ? (
                    <ModalFooter className='d-block'>
                        <Row>
                            <Col xs={9} >
                            </Col>
                            <Col xs={2} className='d-flex justify-content-center'>
                                <button type="button" className='nac-button' onClick={() => { globalContext.set(temp.current); setShowSettings(false); setActiveTab("t1") }}>
                                    <RiCloseLine size={`24pt`} />
                                </button>
                            </Col>
                            <Col xs={1} className='d-flex justify-content-center'>
                                <button type="button" className='nac-button' onClick={() => setSubmitShop(true)}>
                                    <RiCheckLine size={`24pt`} />
                                </button>
                            </Col>
                        </Row>
                    </ModalFooter>
                ) : activeTab == "t5" ? (
                    <ModalFooter className='d-block'>
                        <Row>
                            <Col xs={2} className='d-flex justify-content-center'>
                                {!addGroup && (
                                    <button type="button" className='nac-button' onClick={() => setShowDelConfirm(true)}>
                                        <RiDeleteBin6Line size={`24pt`} />
                                    </button>
                                )}
                            </Col>
                            <Col xs={7} >
                            </Col>
                            <Col xs={2} className='d-flex justify-content-center'>
                                <button type="button" className='nac-button' onClick={() => { globalContext.set.Reloads.agency = true; setShowSettings(false); setActiveTab("t1") }}>
                                    <RiCloseLine size={`24pt`} />
                                </button>
                            </Col>
                            <Col xs={1} className='d-flex justify-content-center'>
                                <button type="button" className='nac-button' onClick={() => setSubmitGroup(true)}>
                                    <RiCheckLine size={`24pt`} />
                                </button>
                            </Col>
                        </Row>
                    </ModalFooter>
                ) : (
                    <ModalFooter className='d-block'>
                        <div className='uss-footer'>
                            <button type="button" className='nac-button' onClick={()=>{setClearUserSettings(true)}}>
                                <RiEraserLine size={`24pt`} />
                            </button>
                            <button type="button" className='nac-button' onClick={()=>{setSubmitUserSettings(true)}}>
                                <RiCheckLine size={`24pt`} />
                            </button>
                        </div>
                    </ModalFooter>
                )}
            </Modal>


            <Modal show={showDelConfirm} onHide={() => setShowDelConfirm(false)}>
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title light-color'>{textContext.get(['sidebar', 'settings', 'del_modal'], ['title'], textContext.value)}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <p>
                        {textContext.get(['sidebar', 'settings', 'del_modal'], ['body'], textContext.value)}
                    </p>
                </ModalBody>
                <ModalFooter className='d-block'>
                    <Row>
                        <Col className='d-flex justify-content-start'>
                            <Button variant='success' onClick={() => setShowDelConfirm(false)}>{textContext.get(['sidebar', 'settings', 'del_modal'], ['cancel'], textContext.value)}</Button>
                        </Col>
                        <Col className='d-flex justify-content-end'>
                            <Button variant='danger' onClick={() => { setDeleteGroup(true); setShowDelConfirm(false) }} >{textContext.get(['sidebar', 'settings', 'del_modal'], ['delete'], textContext.value)}</Button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
            <EventEditor />
        </Col>
    )
}
export default Sidebar